<template>
  <div class="pds-modal-overlay" @click.self="$emit('close')">
    <div class="pds-modal">
      <div class="pds-modal-header">
        <div>
          <h3>{{ title }}</h3>
          <p>Lista detallada de documentos por proveedor</p>
        </div>
        <button @click="$emit('close')"><i class="fa-solid fa-xmark"></i></button>
      </div>
      
      <div class="pds-modal-body">
        <DashboardTable
           title=""
           :showSearch="true"
           searchPlaceholder="Buscar documento o material..."
           :search="tableSearch"
           :searchKeys="['OrdDocumentNumber', 'DocNumSap', 'SupName', 'ItemDescription', 'ItemCode']"
           :filterableColumns="[{ key: 'OrdStatusName', label: 'Todos los estados' }]"
           @update:search="tableSearch = $event"
           :items="data"
           :itemsPerPage="perPage"
           :pagination="true"
           :page="page"
           @update:page="page = $event"
           style="border: none !important; box-shadow: none !important; border-radius: 0 !important; height: 100%;"
           :headers="[
             { label: 'N° OC SUN EXPERT', key: 'OrdDocumentNumber', sortable: true },
             { label: 'N° PEDIDO SAP', key: 'DocNumSap', sortable: true },
             { label: 'Fecha OC', key: 'OrdDate', sortable: true },
             { label: 'Proveedor', key: 'SupName', sortable: true },
             { label: 'Descripción', key: 'ItemDescription', sortable: true },
             { label: 'Monto Total USD', key: 'TotalAmount', sortable: true, align: 'right' },
             { label: 'Saldo Pendiente USD', key: 'PendingBalance', sortable: true, align: 'right' },
             { label: 'Estado', key: 'OrdStatusName', sortable: true, align: 'center' }
           ]"
        >
          <template #row="{ item }">
            <tr :key="item.OrdDocumentNumber + '-' + item.ItemCode">
              <td><span class="pds__badge-oc">{{ item.OrdDocumentNumber }}</span></td>
              <td><span class="pds__badge-oc">{{ item.DocNumSap || '-' }}</span></td>
              <td>{{ item.OrdDate }}</td>
              <td style="font-weight: 600;">{{ item.SupName }}</td>
              <td>
                <div style="font-size: 10px; font-weight: 600; color: var(--pd-text-muted, #64748B);">{{ item.ItemCode }}</div>
                <div style="font-size: 11px; white-space: normal; max-width: 250px; line-height: 1.2;">{{ item.ItemDescription }}</div>
              </td>
              <td class="text-right pds__mono">${{ item.TotalAmount ? item.TotalAmount.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}) : '0.00' }}</td>
              <td class="text-right pds__mono" style="color: #F97316; font-weight: 700;">${{ item.PendingBalance ? item.PendingBalance.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}) : '0.00' }}</td>
              <td class="text-center"><span :class="['pds__estado', statusClass(item.OrdStatus, item.OrdStatusName)]">{{ item.OrdStatusName }}</span></td>
            </tr>
          </template>
        </DashboardTable>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardTable from './DashboardTable.vue';

export default {
  name: 'DashboardKpiModal',
  components: { DashboardTable },
  props: {
    title: { type: String, required: true },
    data: { type: Array, required: true }
  },
  data() {
    return {
      page: 1,
      perPage: 15,
      tableSearch: ''
    };
  },
  watch: {
    data() {
      this.page = 1;
    }
  },
  methods: {
    statusClass(st, name) {
      const u = (name || '').toUpperCase();
      if (u.startsWith('CERR')) return 'pds__estado--closed';

      if (st == null) return '';
      const id = Number(st);
      if (id === 9) return 'pds__estado--closed';
      if ([1, 2, 4, 5, 7, 10].includes(id)) return 'pds__estado--open';
      if ([3, 6, 8].includes(id)) return 'pds__estado--canceled';
      return '';
    }
  }
}
</script>

<style scoped>
/* MODAL OVERLAY Y CONTENEDOR */
.pds-modal-overlay {
  position: fixed !important; top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important;
  background: rgba(15, 23, 42, 0.6) !important;
  backdrop-filter: blur(2px) !important;
  z-index: 9999 !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
  padding: 20px !important;
}
.pds-modal {
  background: var(--pd-bg, #fff) !important;
  border-radius: 16px !important;
  width: 100% !important; max-width: 900px !important; max-height: 85vh !important;
  display: flex !important; flex-direction: column !important;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2) !important;
  overflow: hidden !important;
  animation: modal-fade-in 0.2s ease-out forwards !important;
}

/* CABECERA MODAL */
.pds-modal-header {
  padding: 16px 20px !important;
  background: var(--pd-sidebar-bg, #F8FAFC) !important;
  border-bottom: 1px solid var(--pd-border, #E2E8F0) !important;
  display: flex !important; align-items: flex-start !important; justify-content: space-between !important;
}
.pds-modal-header h3 { font-size: 14px !important; font-weight: 800 !important; color: var(--pd-text-main, #1E293B) !important; margin: 0 0 4px 0 !important; }
.pds-modal-header p { font-size: 11px !important; color: var(--pd-text-muted, #64748B) !important; margin: 0 !important; }
.pds-modal-header button {
  background: none !important; border: none !important; cursor: pointer !important;
  color: var(--pd-text-muted, #94A3B8) !important; font-size: 16px !important; padding: 4px !important;
  border-radius: 6px !important; transition: all 0.15s !important;
}
.pds-modal-header button:hover { background: var(--pd-border, #E2E8F0) !important; color: #EF4444 !important; }

/* CUERPO Y TABLA */
.pds-modal-body {
  flex: 1 !important;
  overflow: hidden !important;
  padding: 0 !important;
  display: flex !important;
  flex-direction: column !important;
}
/* Estilos extraídos al componente DashboardTable */

/* UTILS */
.text-right  { text-align: right !important; }
.text-center { text-align: center !important; }
.pds__empty { text-align: center !important; padding: 32px !important; color: var(--pd-text-muted, #94A3B8) !important; font-size: 12px !important; }
.pds__mono  { font-family: monospace !important; }

.pds__badge-oc { background: var(--pd-table-th-bg, #F1F5F9) !important; border: 1px solid var(--pd-border, #E2E8F0) !important; border-radius: 6px !important; padding: 2px 6px !important; font-size: 10px !important; font-weight: 700 !important; font-family: monospace !important; white-space: nowrap !important; color: var(--pd-text-main, #334155) !important; }
.pds__estado { padding: 3px 8px !important; border-radius: 20px !important; font-size: 9px !important; font-weight: 700 !important; text-transform: uppercase !important; letter-spacing: .4px !important; white-space: nowrap !important; }
.pds__estado--closed   { background: #D1FAE5 !important; color: #065F46 !important; }
.pds__estado--open     { background: #FEF3C7 !important; color: #92400E !important; }
.pds__estado--canceled { background: #FEE2E2 !important; color: #991B1B !important; }

@keyframes modal-fade-in {
  from { opacity: 0; transform: translateY(20px) scale(0.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
</style>

<style>
/* MODO OSCURO (GLOBAL PARA DETECTAR #packaging-dashboard) */
#packaging-dashboard.pd--dark .pds-modal { background: #1E293B !important; }
#packaging-dashboard.pd--dark .pds-modal-header { background: #263548 !important; border-bottom-color: #334155 !important; }
#packaging-dashboard.pd--dark .pds-modal-header h3 { color: #E2E8F0 !important; }
#packaging-dashboard.pd--dark .pds-modal-header p { color: #64748B !important; }
#packaging-dashboard.pd--dark .pds-modal-header button { color: #64748B !important; }
#packaging-dashboard.pd--dark .pds-modal-header button:hover { background: rgba(255,255,255,0.05) !important; color: #EF4444 !important; }

#packaging-dashboard.pd--dark .pds-modal .pds__table thead tr { background: #334155 !important; }
#packaging-dashboard.pd--dark .pds-modal .pds__table th { color: #94A3B8 !important; }
#packaging-dashboard.pd--dark .pds-modal .pds__table td { color: #E2E8F0 !important; border-bottom-color: #334155 !important; }
#packaging-dashboard.pd--dark .pds-modal .pds__table tbody tr:hover { background: rgba(255,255,255,0.03) !important; }

#packaging-dashboard.pd--dark .pds-modal .pds__badge-oc { background: #334155 !important; border-color: #475569 !important; color: #E2E8F0 !important; }

#packaging-dashboard.pd--dark .pds-modal .pds__pagination { background: #263548 !important; border-top-color: #334155 !important; }
#packaging-dashboard.pd--dark .pds-modal .pds__pagination button { background: #1E293B !important; border-color: #334155 !important; color: #CBD5E1 !important; }
#packaging-dashboard.pd--dark .pds-modal .pds__pagination button:hover:not(:disabled) { background: #334155 !important; }
#packaging-dashboard.pd--dark .pds-modal .pds__pagination span { color: #64748B !important; }
#packaging-dashboard.pd--dark .pds-modal .pds__empty { color: #475569 !important; }
</style>
